export const getTableColumnHeaderId = (tableId: string, columnId: string) =>
  `${tableId}-col-${columnId}`

export const getTableColumnHeaderLabelId = (
  tableId: string,
  columnId: string
) => `${tableId}-col-${columnId}-label`
